import { render, staticRenderFns } from "./import-policy.vue?vue&type=template&id=47a84d43&scoped=true&"
import script from "./import-policy.vue?vue&type=script&lang=js&"
export * from "./import-policy.vue?vue&type=script&lang=js&"
import style0 from "./import-policy.vue?vue&type=style&index=0&id=47a84d43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a84d43",
  null
  
)

export default component.exports